export default __webpack_public_path__ + "static/media/winner_checkbox.5cc854b3.svg";